type AnyAll = 'any' | 'all';

export interface SubCondition {
  name: string;
  operation: string;
  value: string;
}

export type Condition = {
  [key in AnyAll]: SubCondition;
};

export interface DropdownOption {
  label: string;
  value: string;
}
